import { FC } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AllieDataGridProps } from './AllieDataGrid.types';
import { DataGrid } from './DataGrid';

const queryClient = new QueryClient();

export const AllieDataGrid: FC<AllieDataGridProps> = ({ ...props }) => (
  <QueryClientProvider client={queryClient}>
    <DataGrid {...props} />
  </QueryClientProvider>
);
